import React, { useEffect, useRef, useState } from 'react'
import { Chip, type IDropdownItem } from 'shared/ui'
import { ChipWithAvatar } from 'entities/Phone/ui/AssignNumberCommon/ui/ChipWithAvatar/ChipWithAvatar'
import styles from './styles.module.scss'

export const RenderItemsContent = ({
  items,
  onDelete,
}: {
  items: IDropdownItem[]
  onDelete: (item: IDropdownItem) => void
}) => {
  const refContainer = useRef<HTMLDivElement>(null)
  const refCollection = useRef<HTMLDivElement>(null)
  const [visibleItemsCount, setVisibleItemsCount] = useState(1)
  useEffect(() => {
    const maxWidth = refContainer.current?.clientWidth || 0
    let width = 0
    let visibleItemsCount = 0
    for (let i = 0; i < items.length; i++) {
      const item = refCollection.current?.children.item(i)
      if (item) {
        width += item.clientWidth
        if (width + 40 + i * 4 > maxWidth) {
          break
        } else {
          visibleItemsCount += 1
        }
      }
    }
    setVisibleItemsCount(visibleItemsCount || 1)
  }, [items])

  return (
    <div className={styles.wrap} ref={refContainer}>
      <div className={styles.collection} ref={refCollection}>
        {items.map((item) => (
          <ChipWithAvatar
            key={item.id}
            item={item}
            label={item.label}
            iconType='div'
            onDelete={(e) => {
              e.stopPropagation()
              onDelete?.(item)
            }}
            isLabelEllipsis={visibleItemsCount === 1}
          />
        ))}
      </div>
      {items.slice(0, visibleItemsCount).map((item) => (
        <ChipWithAvatar
          key={item.id}
          item={item}
          label={item.label}
          iconType='div'
          onDelete={(e) => {
            e.stopPropagation()
            onDelete?.(item)
          }}
          isLabelEllipsis={visibleItemsCount === 1}
        />
      ))}
      {!!items.length && visibleItemsCount < items.length && (
        <Chip label={'+' + (items.length - visibleItemsCount)} />
      )}
    </div>
  )
}
